import { TI, Trans } from 'react-i18next';
import styled from 'styled-components';

import { EvaluationSubmissionResult } from '@treams/treams-network';
import { Paragraph, tokens } from '@treams/treams-ui';

const Copy = styled(Paragraph)`
	margin: 0;
	min-width: 0;

	strong {
		font-weight: ${tokens.typography.weights.medium};
	}
`;

export default function UnsharedAnswerDisplay({ result }: { result: EvaluationSubmissionResult }) {
	const {
		user: { firstName },
	} = result;
	return (
		<Copy>
			<Trans i18nKey="evaluation.unsharedAnswer">
				<strong>{{ firstName } as TI}</strong> heeft nog geen antwoord met je gedeeld.
			</Trans>
		</Copy>
	);
}
